// Controla os campos das informações
(function () {
  'use strict';

  // Variáveis
  const $campoServico = $('#servico');
  const $campoIDLbl = $('.pixel_id_lbl');
  const $campoID = $('#pixel_id');
  const $campoTituloConvWrp = $('.titulo_conversao-wrp');
  const $campoTituloConv = $('#titulo_conversao');
  const $campoDispBoletos = $('#disparar_boletos');
  const $campoDispPix = $('#disparar_pix');
  const $campoEventoBoletosWrp = $('.evento_boletos-wrp');
  const $campoEventoBoletos = $('#evento_boletos');
  const $campoEventoCustomWrp = $('.evento_customizado-wrp');
  const $campoEventoCustom = $('#evento_customizado');
  const $campoIncluirValorFreteWrp = $('.incluir_valor_frete_wrp');
  const $campoIncluirValorFrete = $('#incluir_valor_frete');
  const $campoCodVerDomWrp = $('.codigo_verificacao_dom_wrp');
  const $campoCodVerDom = $('#codigo_verificacao_dom');
  const $campoProcModeWrp = $('.processing-mode-wrp');
  const $campoProcMode = $('input[name="processing_mode"]');
  const $campoFaceTokenWrp = $('.facebook-token-wrp');
  const $campoFaceToken = $('#fb_token');
  const $pagPixelWrp = $('.pag_pixel_wrp');
  const $pagPixel = $('#pixel_pag');
  const $campoBoletosPagosWrp = $('.boletos-pagos-wrp');
  const $campoBoletosPagos = $('#disparar_boletos_pagos');
  const $campoPixPagosWrp = $('.pix-pagos-wrp');
  const $campoPixPagos = $('#disparar_pix_pagos');

  // Verifica se é a página correta
  if ($campoDispBoletos.length > 0) {
    // Evento ao alterar o serviço
    $campoServico.on('change', handlePixelServico);
    // Evento ao alterar o disparo dos boletos
    $campoDispBoletos.on('change', function () {
      handlePixelDispBoletos();
      handlePixelEventosPagos();
    });
    // Evento ao alterar o disparo do pix
    $campoDispPix.on('change', function () {
      handlePixelEventosPagos();
    });
    // Evento ao alterar o evento dos boletos
    $campoEventoBoletos.on('change', handlePixelEventoBoletos);
    // Evento ao alterar a forma de integração (Facebook)
    $campoProcMode.on('change', function () {
      handlePixelFormaIntegracao();
      handlePixelEventosPagos();
    });

    // Ao alterar o serviço
    handlePixelServico();
    function handlePixelServico() {
      const servico = $campoServico.val();
      const disparaBoletos = $campoDispBoletos.is(':checked');
      // Facebook
      if (servico === 'facebook') {
        $campoIDLbl.text('ID do pixel');
        $campoID.attr('placeholder', 'Informe o ID do pixel');
        $campoTituloConvWrp.hide();
        $campoTituloConv.prop('disabled', true).prop('required', false);
        $campoIncluirValorFreteWrp.show();
        $campoIncluirValorFrete.prop('disabled', false);
        $campoCodVerDomWrp.show();
        $campoCodVerDom.prop('disabled', false);
        $campoProcModeWrp.show();
        $campoProcMode.prop('disabled', false);
        $pagPixelWrp.hide();
        $pagPixel.prop('disabled', true).prop('required', false);
      }
      // Google ADS
      else if (servico === 'google_ads') {
        $campoIDLbl.text('ID de conversão');
        $campoID.attr('placeholder', 'Informe o ID de conversão');
        $campoTituloConvWrp.show();
        $campoTituloConv.prop('disabled', false).prop('required', true);
        $campoIncluirValorFreteWrp.hide();
        $campoIncluirValorFrete.prop('disabled', true);
        $campoCodVerDomWrp.hide();
        $campoCodVerDom.prop('disabled', true);
        $campoProcModeWrp.hide();
        $campoProcMode.prop('disabled', true);
        $pagPixelWrp.show();
        $pagPixel.prop('disabled', false).prop('required', true);
      }
      // Taboola
      else if (servico === 'taboola') {
        $campoIDLbl.text('ID do pixel');
        $campoID.attr('placeholder', 'Informe o ID do pixel');
        $campoTituloConvWrp.hide();
        $campoTituloConv.prop('disabled', true).prop('required', false);
        $campoIncluirValorFreteWrp.hide();
        $campoIncluirValorFrete.prop('disabled', true);
        $campoCodVerDomWrp.hide();
        $campoCodVerDom.prop('disabled', true);
        $campoProcModeWrp.hide();
        $campoProcMode.prop('disabled', true);
        $pagPixelWrp.hide();
        $pagPixel.prop('disabled', true).prop('required', false);
      }
      // Pinterest
      else if (servico === 'pinterest') {
        $campoIDLbl.text('ID do pixel');
        $campoID.attr('placeholder', 'Informe o ID do pixel');
        $campoTituloConvWrp.hide();
        $campoTituloConv.prop('disabled', true).prop('required', false);
        $campoIncluirValorFreteWrp.hide();
        $campoIncluirValorFrete.prop('disabled', true);
        $campoCodVerDomWrp.hide();
        $campoCodVerDom.prop('disabled', true);
        $campoProcModeWrp.hide();
        $campoProcMode.prop('disabled', true);
        $pagPixelWrp.hide();
        $pagPixel.prop('disabled', true).prop('required', false);
      }
      // Outbrain
      else if (servico === 'outbrain') {
        $campoIDLbl.text('ID do pixel');
        $campoID.attr('placeholder', 'Informe o ID do pixel');
        $campoTituloConvWrp.hide();
        $campoTituloConv.prop('disabled', true).prop('required', false);
        $campoIncluirValorFreteWrp.hide();
        $campoIncluirValorFrete.prop('disabled', true);
        $campoCodVerDomWrp.hide();
        $campoCodVerDom.prop('disabled', true);
        $campoProcModeWrp.hide();
        $campoProcMode.prop('disabled', true);
        $pagPixelWrp.hide();
        $pagPixel.prop('disabled', true).prop('required', false);
      }
      // Kwai
      else if (servico === 'kwai') {
        $campoIDLbl.text('ID do pixel');
        $campoID.attr('placeholder', 'Informe o ID do pixel');
        $campoTituloConvWrp.hide();
        $campoTituloConv.prop('disabled', true).prop('required', false);
        $campoIncluirValorFreteWrp.hide();
        $campoIncluirValorFrete.prop('disabled', true);
        $campoCodVerDomWrp.hide();
        $campoCodVerDom.prop('disabled', true);
        $campoProcModeWrp.hide();
        $campoProcMode.prop('disabled', true);
        $pagPixelWrp.hide();
        $pagPixel.prop('disabled', true).prop('required', false);
      }
      // TikTok
      else if (servico === 'tiktok') {
        $campoIDLbl.text('ID do pixel');
        $campoID.attr('placeholder', 'Informe o ID do pixel');
        $campoTituloConvWrp.hide();
        $campoTituloConv.prop('disabled', true).prop('required', false);
        $campoIncluirValorFreteWrp.hide();
        $campoIncluirValorFrete.prop('disabled', true);
        $campoCodVerDomWrp.hide();
        $campoCodVerDom.prop('disabled', true);
        $campoProcModeWrp.hide();
        $campoProcMode.prop('disabled', true);
        $pagPixelWrp.hide();
        $pagPixel.prop('disabled', true).prop('required', false);
      }
      handlePixelDispBoletos();
      handlePixelFormaIntegracao();
      handlePixelEventosPagos();
    }

    // Ao alterar o disparo dos boletos
    function handlePixelDispBoletos() {
      const disparaBoletos = $campoDispBoletos.is(':checked');
      const servico = $campoServico.val();
      if (disparaBoletos && servico === 'facebook') {
        $campoEventoBoletosWrp.show();
        $campoEventoBoletos.prop('disabled', false);
        $campoEventoBoletos.prop('required', true);
      } else {
        $campoEventoBoletosWrp.hide();
        $campoEventoBoletos.val('purchase');
        $campoEventoBoletos.prop('disabled', true);
        $campoEventoBoletos.prop('required', false);
      }
      handlePixelEventoBoletos();
    }

    // Ao alterar o evento dos boletos
    function handlePixelEventoBoletos() {
      const evento = $campoEventoBoletos.val();
      if (evento === 'customizado') {
        $campoEventoCustomWrp.show();
        $campoEventoCustom.prop('disabled', false);
        $campoEventoCustom.prop('required', true);
      } else {
        $campoEventoCustomWrp.hide();
        $campoEventoCustom.prop('disabled', true);
        $campoEventoCustom.prop('required', false);
      }
    }

    // Ao alterar a forma de integração (Facebook)
    function handlePixelFormaIntegracao() {
      const servico = $campoServico.val();
      const forma = $('input[name="processing_mode"]:checked').val();
      if (servico === 'facebook' && forma === 'api') {
        $campoFaceTokenWrp.show();
        $campoFaceToken.prop('disabled', false);
        $campoFaceToken.prop('required', true);
      } else {
        $campoFaceTokenWrp.hide();
        $campoFaceToken.prop('disabled', true);
        $campoFaceToken.prop('required', false);
      }
    }

    // Exibe/oculta campos para disparo de boleto ou pix pagos
    function handlePixelEventosPagos() {
      const servico = $campoServico.val();
      const forma = $('input[name="processing_mode"]:checked').val();
      if (servico === 'facebook' && forma === 'api' && $campoDispBoletos.is(':checked')) {
        $campoBoletosPagosWrp.show();
        $campoBoletosPagos.prop('disabled', false);
      } else {
        $campoBoletosPagosWrp.hide();
        $campoBoletosPagos.prop('disabled', true);
      }
      /* if (servico === 'facebook' && forma === 'api' && $campoDispPix.is(':checked')) {
        $campoPixPagosWrp.show();
        $campoPixPagos.prop('disabled', false);
      } else {
        $campoPixPagosWrp.hide();
        $campoPixPagos.prop('disabled', true);
      } */
    }
  }
})();
